import {
  biGridBottom,
  biMoveGridItem,
} from '@euler/app/flows/bi-dashboards/functions/biGridLayout';
import {
  BiDashboardLayout,
  BiLayoutMode,
  BiPlacement,
  BiPlacementEdge,
} from '@euler/model/bi/dashboard';

/**
 * `place_card` as the server's layout engine does it, near enough for the
 * playground: a preset reorders `order`; a custom grid puts the card at
 * the anchor's cell (or below it) and lets the rest settle.
 */
export function biFixturePlaceCard(
  layout: BiDashboardLayout,
  cardId: string,
  placement: BiPlacement,
): BiDashboardLayout {
  const { anchor } = placement;
  if (layout.mode === BiLayoutMode.Preset) {
    const order = layout.order.filter(id => id !== cardId);
    let index = order.length;
    if (anchor === BiPlacementEdge.Top) index = 0;
    else if (typeof anchor === 'object')
      index =
        'before' in anchor
          ? order.indexOf(anchor.before)
          : order.indexOf(anchor.after) + 1;
    order.splice(Math.max(index, 0), 0, cardId);
    return { ...layout, order };
  }
  const others = layout.items.filter(item => item.cardId !== cardId);
  let x = 0;
  let y = 0;
  if (anchor === BiPlacementEdge.Bottom) y = biGridBottom(others);
  else if (typeof anchor === 'object') {
    const id = 'before' in anchor ? anchor.before : anchor.after;
    const target = others.find(item => item.cardId === id);
    if (target) {
      x = target.x;
      y = 'before' in anchor ? target.y : target.y + target.h;
    }
  }
  return {
    mode: BiLayoutMode.Custom,
    items: biMoveGridItem(layout.items, cardId, x, y),
  };
}
